import React, { Component } from 'react';
import { TextArea } from '../../../../commonModules/interface/form-input-inline';
import { Box, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

class AddComment extends Component {
    state = {  }
    handleChange = (e) => {
        this.props.handleChange(e)
    }
    render() {
        return (
            <Box>
                <TextArea
                    id="comment" 
                    onChange={this.handleChange} 
                    value={this.props.comment} 
                    name="comment" 
                    rows={5}
                    label="Commentaire"
                    error={this.props.errors.comment}
                />
                {this.props.userInfo.activeAlert &&
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Alerte en Cours, Desactiver ?</FormLabel>
                        <RadioGroup 
                            aria-label="alertDone" 
                            name="alertDone" 
                            value={this.props.alertDone} 
                            onChange={this.handleChange }
                            style={{ flexDirection: "row"}}
                            error={this.props.errors.alertDone}
                        >
                            <FormControlLabel value="oui" control={<Radio />} label="Oui, probème résolu" />
                            <FormControlLabel value="non" control={<Radio />} label="Non, pas encore résolu" />
                        </RadioGroup>
                    </FormControl>
                }
            </Box>
        );
    }
}

export default AddComment;